import { render, staticRenderFns } from "./businessHandlingCenter.vue?vue&type=template&id=2131f9b6&scoped=true&"
import script from "./businessHandlingCenter.vue?vue&type=script&lang=js&"
export * from "./businessHandlingCenter.vue?vue&type=script&lang=js&"
import style0 from "./businessHandlingCenter.vue?vue&type=style&index=0&id=2131f9b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2131f9b6",
  null
  
)

export default component.exports